(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abmium-antibody-validation-course"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.abm-avc'):null;
  if(!root){root=document.querySelector('.abm-avc:last-of-type');}
  if(!root)return;
  var sid=root.id.replace('abm-avc-','');
  var modules=Array.prototype.slice.call(root.querySelectorAll('.abm-avc-module'));
  var nav=Array.prototype.slice.call(root.querySelectorAll('#abmAvcNav-'+sid+' button'));
  var key='abmium_course_antibody_validation_v1';
  var handles=['foundations','design','western-blot','immunofluorescence','ihc','immunoprecipitation','flow-cytometry','elisa','evidence','capstone'];
  var courseId='antibody-validation-reproducible-research';
  function load(){try{return JSON.parse(localStorage.getItem(key))||{current:0,completed:[],score:null,certificateId:null,startedAt:Date.now()};}catch(e){return{current:0,completed:[],score:null,certificateId:null,startedAt:Date.now()};}}
  var state=load();
  function save(){try{localStorage.setItem(key,JSON.stringify(state));}catch(e){}}
  function pct(){return Math.round((state.completed.length/handles.length)*100);}
  function updateProgress(){
    var p=pct();
    root.querySelector('#abmAvcPercent-'+sid).textContent=p+'%';
    root.querySelector('#abmAvcCount-'+sid).textContent=state.completed.length+' / '+handles.length+' complete';
    root.querySelector('#abmAvcSideProgress-'+sid).style.width=p+'%';
    root.querySelector('#abmAvcTopProgress-'+sid).style.width=p+'%';
    nav.forEach(function(btn,i){btn.classList.toggle('is-complete',state.completed.indexOf(handles[i])>-1);});
  }
  function show(i,scroll){
    i=Math.max(0,Math.min(modules.length-1,i));
    state.current=i;save();
    modules.forEach(function(m,x){m.hidden=x!==i;});
    nav.forEach(function(b,x){b.classList.toggle('is-active',x===i);});
    root.querySelector('#abmAvcBreadcrumb-'+sid).textContent='Module '+(i+1)+' of '+modules.length;
    root.querySelector('#abmAvcPosition-'+sid).textContent=(i+1)+' / '+modules.length;
    root.querySelector('#abmAvcPrev-'+sid).disabled=i===0;
    root.querySelector('#abmAvcNext-'+sid).disabled=i===modules.length-1;
    var btn=modules[i].querySelector('.abm-avc-complete');
    if(btn&&state.completed.indexOf(handles[i])>-1){btn.classList.add('is-complete');btn.textContent='Completed · Continue';}
    if(scroll){root.querySelector('.abm-avc-toolbar').scrollIntoView({behavior:'smooth',block:'start'});}
  }
  nav.forEach(function(btn){btn.addEventListener('click',function(){show(parseInt(btn.dataset.index,10),true);});});
  root.querySelector('#abmAvcPrev-'+sid).addEventListener('click',function(){show(state.current-1,true);});
  root.querySelector('#abmAvcNext-'+sid).addEventListener('click',function(){show(state.current+1,true);});
  root.querySelector('#abmAvcResume-'+sid).addEventListener('click',function(){show(state.current,true);});

  root.querySelectorAll('.abm-avc-check-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var box=btn.closest('.abm-avc-check'), chosen=box.querySelector('input:checked'), feedback=box.querySelector('.abm-avc-feedback');
      if(!chosen){feedback.textContent='Choose an answer first.';feedback.className='abm-avc-feedback bad';return;}
      if(chosen.value===box.dataset.answer){feedback.textContent='Correct. The conclusion stays tied to the tested application and controls.';feedback.className='abm-avc-feedback good';}
      else{feedback.textContent='Not quite. Revisit what the control can actually establish before extending the claim.';feedback.className='abm-avc-feedback bad';}
    });
  });

  root.querySelectorAll('.abm-avc-complete').forEach(function(btn){
    btn.addEventListener('click',function(){
      var mod=btn.closest('.abm-avc-module'), handle=mod.dataset.module;
      if(state.completed.indexOf(handle)<0)state.completed.push(handle);
      save();updateProgress();
      btn.classList.add('is-complete');btn.textContent='Completed · Continue';
      if(window.AbmiumLMS){
        try{
          window.AbmiumLMS.registerCourse(courseId,'Antibody Validation for Reproducible Research',handles);
          window.AbmiumLMS.markComplete(courseId,handle);
        }catch(e){}
      }
      if(state.current<modules.length-1)show(state.current+1,true);
    });
  });

  function candidateId(){
    if(state.certificateId)return state.certificateId;
    var chars='ABCDEFGHJKLMNPQRSTUVWXYZ23456789',out='';
    var bytes=new Uint8Array(6);
    if(window.crypto&&window.crypto.getRandomValues){window.crypto.getRandomValues(bytes);for(var i=0;i<6;i++)out+=chars[bytes[i]%chars.length];}
    else{for(var j=0;j<6;j++)out+=chars[Math.floor(Math.random()*chars.length)];}
    state.certificateId='ABM-TRN-'+new Date().getFullYear()+'-'+out;save();return state.certificateId;
  }
  var finalForm=root.querySelector('#abmAvcFinal-'+sid);
  finalForm.addEventListener('submit',function(e){
    e.preventDefault();
    var sets=Array.prototype.slice.call(finalForm.querySelectorAll('fieldset')), correct=0, answered=0;
    sets.forEach(function(fs){var c=fs.querySelector('input:checked');if(c){answered++;if(c.value===fs.dataset.answer)correct++;}});
    var score=Math.round(correct/sets.length*100), out=root.querySelector('#abmAvcScore-'+sid);
    if(answered<sets.length){out.className='abm-avc-score fail';out.textContent='Please answer all five questions before scoring.';return;}
    state.score=score;
    if(score>=80){
      if(state.completed.indexOf('capstone')<0)state.completed.push('capstone');
      state.completedAt=Date.now();save();updateProgress();
      out.className='abm-avc-score pass';out.textContent='Pass · '+score+'%. Certificate request unlocked.';
      var cert=root.querySelector('#abmAvcCertificate-'+sid);cert.hidden=false;
      var id=candidateId();
      root.querySelector('#abmAvcCertId-'+sid).textContent=id;
      root.querySelector('#abmAvcCertIdInput-'+sid).value=id;
      root.querySelector('#abmAvcScoreInput-'+sid).value=score+'%';
      root.querySelector('#abmAvcCompletedInput-'+sid).value=new Date(state.completedAt).toISOString();
      if(window.AbmiumLMS){
        try{window.AbmiumLMS.registerCourse(courseId,'Antibody Validation for Reproducible Research',handles);window.AbmiumLMS.markComplete(courseId,'capstone');}catch(err){}
      }
      cert.scrollIntoView({behavior:'smooth',block:'start'});
    }else{
      save();out.className='abm-avc-score fail';out.textContent='Score '+score+'%. A minimum of 80% is required. Review the modules and try again.';
    }
  });

  updateProgress();show(typeof state.current==='number'?state.current:0,false);
  if(state.score>=80){
    var cert=root.querySelector('#abmAvcCertificate-'+sid);cert.hidden=false;
    var id=candidateId();
    root.querySelector('#abmAvcCertId-'+sid).textContent=id;
    root.querySelector('#abmAvcCertIdInput-'+sid).value=id;
    root.querySelector('#abmAvcScoreInput-'+sid).value=state.score+'%';
    root.querySelector('#abmAvcCompletedInput-'+sid).value=state.completedAt?new Date(state.completedAt).toISOString():'';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abmium-marketplace-header"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-abm-header]');if(!root||root.dataset.ready)return;root.dataset.ready='true';const menu=root.querySelector('[data-abm-menu]');const navigation=root.querySelector('#AbmiumDesktopNavigation');root.querySelector('[data-abm-toggle-navigation]')?.addEventListener('click',event=>{const expanded=event.currentTarget.getAttribute('aria-expanded')==='true';event.currentTarget.setAttribute('aria-expanded',String(!expanded));if(navigation)navigation.hidden=expanded});root.querySelectorAll('[data-abm-open-menu]').forEach(button=>button.addEventListener('click',()=>{if(menu&&!menu.open)menu.showModal()}));root.querySelectorAll('[data-abm-close-menu]').forEach(button=>button.addEventListener('click',()=>menu&&menu.close()));menu?.addEventListener('click',event=>{if(event.target===menu)menu.close()});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.open)menu.close()});root.querySelectorAll('[data-abm-focus-search]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('.header-global-search-input');window.scrollTo({top:0,behavior:'smooth'});window.setTimeout(()=>input?.focus(),220)}));const input=root.querySelector('.header-global-search-input');const prompts=['Search for antibodies...','Search for ELISA kits...','Search for proteins...','Search for recombinant proteins...','Search for DNA extraction kits...'];let promptIndex=0;if(input&&window.matchMedia('(min-width:750px)').matches&&!input.value){input.placeholder=prompts[0];window.setInterval(()=>{if(document.activeElement!==input&&!input.value){promptIndex=(promptIndex+1)%prompts.length;input.placeholder=prompts[promptIndex]}},2800)}document.addEventListener('abmium:cart',event=>{const count=Number(event.detail?.count||0);document.querySelectorAll('[data-abm-cart-count]').forEach(node=>{node.textContent=String(count);node.hidden=count===0})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abmium-research-organisations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-abm-logo-rail]').forEach(rail => {
      if (rail.dataset.abmCarouselReady === 'true') return;
      rail.dataset.abmCarouselReady = 'true';

      const controls = rail.parentElement.querySelector('.abm-research-footer__controls');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let pausedUntil = 0;
      const pause = () => { pausedUntil = Date.now() + 12000; };
      const maxScroll = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
      const stepSize = () => {
        const item = rail.querySelector('.abm-research-footer__organisation');
        const gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      };
      const advance = direction => {
        const max = maxScroll();
        if (max <= 2) return;
        const step = stepSize();
        const target = direction > 0
          ? (rail.scrollLeft >= max - 3 ? 0 : Math.min(max, rail.scrollLeft + step))
          : (rail.scrollLeft <= 3 ? max : Math.max(0, rail.scrollLeft - step));
        rail.scrollTo({left: target, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      };

      controls?.querySelector('[data-abm-prev]')?.addEventListener('click', () => {pause();advance(-1);});
      controls?.querySelector('[data-abm-next]')?.addEventListener('click', () => {pause();advance(1);});
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin', 'mouseenter'].forEach(type => {
        rail.addEventListener(type, pause, {passive: type !== 'keydown'});
      });
      const updateControls = () => {if (controls) controls.hidden = maxScroll() <= 2;};
      updateControls();
      window.addEventListener('resize', updateControls, {passive:true});

      const timer = window.setInterval(() => {
        if (!rail.isConnected) {window.clearInterval(timer);return;}
        if (document.hidden || reducedMotion.matches || Date.now() < pausedUntil || rail.matches(':focus-within, :hover')) return;
        const rect = rail.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        advance(1);
      }, 4400);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abmium-v4-content-page"]) return;
  try {
    
(function(){
  function init(root){
    var content=root.querySelector('[data-ab4-content]');
    var nav=root.querySelector('[data-ab4-toc]');
    var list=root.querySelector('[data-ab4-toc-list]');
    if(!content||!nav||!list)return;
    content.querySelectorAll('table').forEach(function(table){
      if(table.parentElement&&table.parentElement.classList.contains('table-wrapper'))return;
      var wrap=document.createElement('div');
      wrap.className='table-wrapper';
      table.parentNode.insertBefore(wrap,table);
      wrap.appendChild(table);
    });
    var headings=Array.prototype.slice.call(content.querySelectorAll('h2'));
    if(headings.length<2)return;
    headings.forEach(function(h,index){
      if(!h.id){
        var slug=(h.textContent||'section-'+(index+1)).toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
        h.id=slug||('section-'+(index+1));
      }
      var li=document.createElement('li');
      var a=document.createElement('a');
      a.href='#'+h.id;
      a.textContent=h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.hidden=false;
  }
  document.querySelectorAll('[data-ab4-page]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){
    var root=e.target.querySelector('[data-ab4-page]');
    if(root)init(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
